<div [id]="'showHeurekaBadgeHere-' + (widgetSize$ | async)" class="heureka-widget"></div>
